import axios from '../core/axios';
import { EditCalendarAccountParams, UnlinkCalendarName } from '../model/calendar.model';

import { ApiConstants } from './api-constants';
export class CalendarService {
  static getAllAccounts = async () => {
    return await (
      await axios.get(ApiConstants.CALENDAR_API.AVAILABLE_CURRENT_ACCOUNT.URL())
    ).data;
  };
  static editCalendarAccount = async (email: string, payload: EditCalendarAccountParams) => {
    return await (
      await axios.patch(ApiConstants.CALENDAR_API.EDIT_CURRENT_ACCOUNT.URL(email), payload)
    ).data;
  };
  static getGoogleEvents = async (query: any) => {
    return await (
      await axios.get(
        ApiConstants.CALENDAR_API.GOOGLE_CALENDAR.URL() +
          ApiConstants.CALENDAR_API.GOOGLE_CALENDAR.QUERY_PARAMS(query),
      )
    ).data;
  };
  static getZoomEvents = async (query: any) => {
    return await (
      await axios.get(
        ApiConstants.CALENDAR_API.ZOOM_CALENDAR.URL(),
        // +ApiConstants.CALENDAR_API.ZOOM_CALENDAR.QUERY_PARAMS(query),
      )
    ).data;
  };
  static createGoogleEvents = async (email: string, payload: any) => {
    return await (
      await axios.post(ApiConstants.CALENDAR_API.CREATE_GOOGLE_EVENT.URL(email), payload)
    ).data;
  };
  static editGoogleEvents = async (id: string, email: string, payload: any) => {
    return await (
      await axios.patch(ApiConstants.CALENDAR_API.EDIT_GOOGLE_EVENT.URL(email, id), payload)
    ).data;
  };
  static createZoomEvents = async (email: string, payload: any) => {
    return await (
      await axios.post(ApiConstants.CALENDAR_API.CREATE_ZOOM_EVENT.URL(email), payload)
    ).data;
  };
  static editZoomEvents = async (id: string, email: string, payload: any) => {
    return await (
      await axios.patch(ApiConstants.CALENDAR_API.EDIT_ZOOM_EVENT.URL(email, id), payload)
    ).data;
  };
  static createMSEvents = async (email: string, payload: any) => {
    return await (
      await axios.post(ApiConstants.CALENDAR_API.CREATE_MS_EVENT.URL(email), payload)
    ).data;
  };
  static editMSEvents = async (id: string, email: string, payload: any) => {
    return await (
      await axios.patch(ApiConstants.CALENDAR_API.EDIT_MS_EVENT.URL(email, id), payload)
    ).data;
  };
  static deleteGoogleEvents = async (email: string, meetID: any) => {
    return await (
      await axios.delete(ApiConstants.CALENDAR_API.DELETE_GOOGLE_EVENT.URL(email, meetID))
    ).data;
  };
  static deleteZoomEvents = async (email: string, meetID: any) => {
    return await (
      await axios.delete(ApiConstants.CALENDAR_API.DELETE_ZOOM_EVENT.URL(email, meetID))
    ).data;
  };
  static deleteMSEvents = async (email: string, meetID: any) => {
    return await (
      await axios.delete(ApiConstants.CALENDAR_API.DELETE_MS_EVENT.URL(email, meetID))
    ).data;
  };

  static unlinkAccount = async (integration: UnlinkCalendarName, email: string) => {
    return await (
      await axios.delete(ApiConstants.CALENDAR_API.CALENDAR_UNLINK.URL(integration, email))
    ).data;
  };
}
